module.exports = __webpack_public_path__ + "static/media/yellowcat2.97df8175.png";